{
  "instances": {
    "scheduledtasks": {
      "label": "스케쥴 작업",
      "no_scheduledtasks": "스케쥴 작업이 없습니다.",
      "cron": {
        "expression": "표현식",
        "runnable": "실행가능",
        "title": "Cron"
      },

      "fixed_delay": {
        "initial_delay_ms": "기본 지연 (ms)",
        "interval_ms": "반복 주기 (ms)",
        "runnable": "실행가능",
        "title": "고정 지연"
      },
      "fixed_rate": {
        "initial_delay_ms": "기본 지연(ms)",
        "interval_ms": "반복 주기 (ms)",
        "runnable": "실행가능",
        "title": "고정 비율"
      }
    }
  }
}
